import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { IUser } from "../types/reducers/authReducer";
import { getDefaultLandingPage } from "../utils/permissions";
import { EmptyStateContactsPage } from "../components/ContactsPage/EmptyStateContactsPage";
import emptyStateIcon from "../assets/images/EmptyStateContacts.svg";
import { useTranslation } from "../hooks/useTranslation";

/**
 * Stage 1B-1 Task 10: where a route guard sends someone it keeps out -- his own
 * landing page (as RoleRoute already did), never "/", which is the public
 * marketing page outside the app.
 *
 * When his landing page IS the page he was kept out of (a freshly invited
 * `limited` member with nothing granted lands on /households and cannot open
 * it), redirecting would send him to the same blocked page forever, so he is
 * shown the same "no permission" empty state TeamPage uses instead.
 */
export const RedirectToLanding: FC<{ user: IUser | null }> = ({ user }) => {
  const { pathname } = useLocation();
  const { p } = useTranslation("general");
  const target = getDefaultLandingPage(user);
  if (target === pathname) {
    return <EmptyStateContactsPage img={emptyStateIcon} title={p("no_page_permission")} />;
  }
  return <Navigate to={target} replace />;
};
